"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartners = exports.DemandPartner = exports.DemandPartnerType = exports.DemandPartnerParam = exports.DemandPartnerField = void 0;
class DemandPartnerField {
}
exports.DemandPartnerField = DemandPartnerField;
class DemandPartnerParam {
}
exports.DemandPartnerParam = DemandPartnerParam;
class DemandPartnerType {
}
exports.DemandPartnerType = DemandPartnerType;
class DemandPartner {
}
exports.DemandPartner = DemandPartner;
class DemandPartners {
    constructor() {
        this.client = [];
        this.server = [];
    }
    get length() {
        var _a, _b;
        return (((_a = this.client) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = this.server) === null || _b === void 0 ? void 0 : _b.length) || 0);
    }
}
exports.DemandPartners = DemandPartners;
//# sourceMappingURL=demand-partner.js.map